import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './TextListContainer.module.css';

//#region [Component]
type TextListContainerProps = React.ComponentPropsWithoutRef<'section'>;
export default function TextListContainer(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(styles.STextListContainer, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <section className={t1} {...rest}>{children}</section>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
//#endregion